import { auth, usersCollection } from './firebase'
import store from './store'
import constants from './store/constants'

const ACCOUNT_TYPES = constants.ACCOUNT_TYPES

let unsubscribeUser = null

// https://firebase.google.com/docs/auth/web/manage-users
auth.onAuthStateChanged(function(user) {
  if (unsubscribeUser) {
    unsubscribeUser()
    unsubscribeUser = null
  }

  if (user) {
    const newUser = {
      id: user.uid,
      name: user.displayName ? user.displayName.split(' ')[0] : 'User',
      account: ACCOUNT_TYPES.FREE,
      email: user.email
    }

    const userRef = usersCollection.doc(user.uid)
    unsubscribeUser = userRef.onSnapshot(
      doc => {
        if (!doc.exists) {
          userRef.set(newUser)
        } else {
          const data = doc.data()
          newUser.account = data.account || ACCOUNT_TYPES.FREE
          store.commit('USER_DETAILS', newUser)
        }
      },
      error => {
        console.error('Error listening to user document changes:', error)
      }
    )

    store.commit('USER_DETAILS', newUser)
  }
})
